var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.ready
    ? _c("div", {}, [
        _vm.loading
          ? _c(
              "span",
              { staticClass: "loading" },
              [
                _c("ClipLoader", {
                  attrs: { color: "#2e3f50", loading: _vm.loading, size: 20 },
                }),
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "edit-section" }, [
          _c("a", { on: { click: _vm.editStudentCourses } }, [_vm._v("ערוך")]),
        ]),
        _vm.studentCoursesModel && _vm.studentCoursesModel.length
          ? _c(
              "div",
              { staticClass: "StudentGroups__Container" },
              _vm._l(_vm.studentCoursesModel, function (course) {
                return _c(
                  "div",
                  {
                    key: course.id,
                    staticClass: "StudentGroupsWidget__Component",
                    class: [course.isSelected && "green"],
                  },
                  [_c("p", [_vm._v(_vm._s(course.courseName))])]
                )
              }),
              0
            )
          : _vm._e(),
        !_vm.loading && !_vm.studentCoursesModel.length
          ? _c("div", [_vm._v("אין קורסים משויכים למשתמש")])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }